import React from "react";
import "./ETP.css";
import {Link} from 'react-router-dom';

export default function ETPPage() {
  return (
   

<div className="etp-page">

  {/* Hero Section */}
  <section
  className="hero-etp"
  style={{
    backgroundImage: "url('/images/ETP-1.png')",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  }}
>
  {/* Overlay */}
  <div
    className="hero-etp-overlay">
    <div className="hero-etp-text">
      <h1>Effluent Treatment Plant</h1>
      <p>
        Sustainable solutions for treating industrial waste water, ensuring safe discharge,
        compliance, and water reuse.
      </p>
      <Link to="/contact">
      <button className="cta-btn">Explore Solutions</button></Link>
    </div>
  </div>
</section>


  {/* Description Section */}
  <section className="intro-etp">
    <div className="intro-etp-text">
      <h2>Advanced Solutions for Industrial Wastewater</h2>
      <p>
        Effluent treatment plants (ETPs) are designed to remove harmful chemicals,
        heavy metals, and organic matter from industrial wastewater. Our systems
        combine neutralization, biological treatment, filtration, and polishing
        to protect ecosystems and enable sustainable reuse.
      </p>
    </div>
    <div className="intro-etp-image">
      <img
        src="/images/ETP-2.png"
        alt="Industrial wastewater treatment process"
        loading="lazy"
      />
    </div>
  </section>

  {/* Applications Section */}
  <section className="applications-etp">
  <h2>Applications</h2>
  <div className="app-etp-grid">
    <div className="app-etp-card">
      <h3>Electroplating Industries</h3>
      <p>Removes heavy metals and toxic residues from plating wastewater.</p>
    </div>
    <div className="app-etp-card">
      <h3>Textile Industries</h3>
      <p>Treats dye-laden effluents and organic load from washing and processing.</p>
    </div>
    <div className="app-etp-card">
      <h3>Distilleries</h3>
      <p>Handles high-BOD wastewater from fermentation and distillation processes.</p>
    </div>
    <div className="app-etp-card">
      <h3>Pharmacy Industries</h3>
      <p>Removes pharmaceutical residues and chemical contaminants from production waste.</p>
    </div>
    <div className="app-etp-card">
      <h3>Chemical Industries</h3>
      <p>Neutralizes acids, alkalis, and hazardous chemical effluents.</p>
    </div>
    <div className="app-etp-card">
      <h3>Paper Industries</h3>
      <p>Treats pulp-based wastewater with high organic and suspended solids.</p>
    </div>
    <div className="app-etp-card">
      <h3>Tannery Industries</h3>
      <p>Removes chromium, sulfides, and organic matter from leather processing waste.</p>
    </div>
    <div className="app-etp-card">
      <h3>Dye & Dye Intermediaries</h3>
      <p>Degrades complex dye molecules and colorants from effluent streams.</p>
    </div>
    <div className="app-etp-card">
      <h3>Edible Oil Refineries</h3>
      <p>Treats oil-laden wastewater and organic residues from refining operations.</p>
    </div>
  </div>
</section>

  {/* Advantages Section */}
<section className="advantages-etp">
  <h2>Advantages</h2>
  <div className="adv-etp-list">

    <div className="adv-etp-item">
      <span className="adv-icon">🛡️</span>
      <div>
        <h3>Compliance</h3>
        <p>Totally integrated zero discharge system ensuring regulatory adherence.</p>
      </div>
    </div>

    <div className="adv-etp-item">
      <span className="adv-icon">🌍</span>
      <div>
        <h3>Eco-Friendly</h3>
        <p>Reduces ecological footprint by minimizing harmful pollutants.</p>
      </div>
    </div>

    <div className="adv-etp-item">
      <span className="adv-icon">💧</span>
      <div>
        <h3>Sustainability</h3>
        <p>By-products are marketable commodities in most cases, supporting circular economy practices.</p>
      </div>
    </div>

    <div className="adv-etp-item">
      <span className="adv-icon">⚙️</span>
      <div>
        <h3>Efficiency</h3>
        <p>Complete use of condensate water for optimized resource utilization.</p>
      </div>
    </div>

    <div className="adv-etp-item">
      <span className="adv-icon">🏗️</span>
      <div>
        <h3>Compact Design</h3>
        <p>Space-saving plant layout requiring minimal installation area.</p>
      </div>
    </div>

    <div className="adv-etp-item">
      <span className="adv-icon">🔬</span>
      <div>
        <h3>Operational Stability</h3>
        <p>No scaling or froth formation in evaporators, ensuring smooth performance.</p>
      </div>
    </div>

    <div className="adv-etp-item">
      <span className="adv-icon">🤝</span>
      <div>
        <h3>User-Friendly</h3>
        <p>Easy to operate and maintain, designed for hassle-free usage.</p>
      </div>
    </div>

  </div>
</section>

  {/* Technical Specifications Section */}
 <section className="technical-etp-specs">
  <h2>Technical Specifications</h2>
  <div className="spec-etp-grid">
    <div className="spec-etp-item">⚙️ Equalization</div>
    <div className="spec-etp-item">⚗️ Acidification</div>
    <div className="spec-etp-item">🧪 Pressure Filter</div>
    <div className="spec-etp-item">🌊 Primary Floatation</div>
    <div className="spec-etp-item">🥛 Fat Recovery</div>
    <div className="spec-etp-item">🔍 Filter Process</div>
    <div className="spec-etp-item">⚖️ Neutralization</div>
    <div className="spec-etp-item">❄️ Cooling & Mixing</div>
    <div className="spec-etp-item">🧴 Chemical Conditioning</div>
    <div className="spec-etp-item">🪣 Sludge Setting & Separation</div>
    <div className="spec-etp-item">🚮 Removal of Chemical Sludge</div>
    <div className="spec-etp-item">🌱 Biological Oxidation (Activated Sludge)</div>
    <div className="spec-etp-item">♻️ Bio-clarification / Sludge Recycle</div>
    <div className="spec-etp-item">⬆️ Upflow Pressure Solid Filtration</div>
    <div className="spec-etp-item">🪶 Activated Carbon Filter</div>
  </div>
</section>

  {/* CTA Section */}
  <section className="cta-etp">
    <h2>Protect the environment with efficient effluent treatment</h2>
    <div className="cta-etp-buttons">
      <Link to="/contact">
      <button className="cta-etp-btn primary">Get a Quote</button>
      </Link>
      <a href="/Brochure.pdf" download  className="cta-etp-btn secondary">Download Brochure</a>
    </div>
  </section>

</div>
  );
}